import script from "./ViewBusinessHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBusinessHandler.vue?vue&type=script&setup=true&lang=js"

import "./ViewBusinessHandler.vue?vue&type=style&index=0&id=6c5b1f3b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5b1f3b"]])

export default __exports__